/**
 * Bridge to the one Hottie brain (`useHottieChat.send`).
 * Voice calls this so the sheet transcript and tool loop stay on that path.
 */

export type HottieChatSend = (text: string) => Promise<string | undefined>;

let sendFn: HottieChatSend | null = null;

export function registerHottieChatSend(fn: HottieChatSend | null): void {
  sendFn = fn;
}

export function sendThroughHottieChat(text: string): Promise<string | undefined> {
  const trimmed = text.trim();
  if (!trimmed || !sendFn) return Promise.resolve(undefined);
  return sendFn(trimmed);
}
